import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import {AuthGuard} from "./shared/guards/auth.guard";
import {AdminGuard} from "./shared/guards/admin.guard";
import {AmazonGuard} from "./shared/guards/amazon.guard";
import {ErrorComponent} from "./error/error.component";
import {ProfileComponent} from "./profile/profile.component";
import {LoginComponent} from "./login/login.component";
import {SLBGuard} from "./shared/guards/slb.guard";
import {DellGuard} from "./shared/guards/dell.guard";
import {SEOGuard} from "./shared/guards/seo.guard";
import {DemoGuard} from "./shared/guards/demo.guard";
import {FTNTGuard} from "./shared/guards/ftnt.guard";
import {TRDGuard} from './shared/guards/trd.guard';

export const routes:Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'error', component: ErrorComponent},
  {path: 'profile', component: ProfileComponent, canActivate: [AuthGuard]},
  {path: 'admin', loadChildren: './admin/admin.module#AdminModule', canActivate: [AuthGuard, AdminGuard]},
  {path: 'external', loadChildren: './external/external.module#ExternalModule', canActivate: [AuthGuard]},
  {path: 'amazon', loadChildren: './amazon/amazon.module#AmazonModule', canActivate: [AuthGuard, AmazonGuard]},
  { path: 'slt', loadChildren: './slt/slt.module#SLTModule' ,canActivate:[AuthGuard, SLBGuard]},
  { path: 'trd', loadChildren: './trd/trd.module#TRDModule' ,canActivate:[AuthGuard, TRDGuard]},
  { path: 'dell', loadChildren: './dell/dell.module#DellModule' ,canActivate:[AuthGuard, DellGuard]},
  { path: 'seo', loadChildren: './seo/seo.module#SEOModule' ,canActivate:[AuthGuard, SEOGuard]},
  { path: 'demo', loadChildren: './demo/demo.module#DemoModule' ,canActivate:[AuthGuard, DemoGuard]},
  { path: 'fortinet', loadChildren: './fortinet/ftnt.module#FtntModule', canActivate:[AuthGuard, FTNTGuard]},
  {path: '', redirectTo: '/login', pathMatch: 'full'},

];

export const routing:ModuleWithProviders = RouterModule.forRoot(routes, {useHash: true});



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/app.routing.ts